import React, { useStat, useEffect, useRef, useState } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import "../../../../../../../css/workspace.css";
import $ from "jquery";
import marked from "marked";
import {
  Button,
  Tabs,
  Avatar,
  Card,
  Popover,
  Checkbox,
  Tooltip,
  Input,
  Upload,
  Table,
  Tag,
  Space,
  Select,
  Image,
  Radio,
  Switch
} from "antd";
import {
  AppstoreOutlined,
  FileTextOutlined,
  LinkOutlined,
  InfoCircleOutlined,
  PlusCircleOutlined,
  FileAddOutlined,
  CloseCircleTwoTone,
  DeleteTwoTone,
  ExportOutlined,
  FullscreenExitOutlined,
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  TagsOutlined,
  CheckCircleOutlined,
  PlayCircleOutlined,
  StopOutlined,
  GlobalOutlined,
  PauseCircleOutlined,
  FontSizeOutlined,
} from "@ant-design/icons";
import { Line, Bar, Pie, Doughnut, PolarArea, Radar } from "react-chartjs-2";
import {
  getSqlQueryV2,
  queryDocumentV2,
  sendInputAnswerV2,
  getAudio,
  thumbsAction,
  getChatHistoryV2,
  getLiveSearchQuery,
  getTrainedDataV2
} from "../../../../../../../redux/actions/collectionsV2";
import fileIcon from "../../../../../../../images/collection-icons/file-text-big.svg";
import { notify } from "../../../../../../../components/Snack";
import micRecording from "../../../../../../../images/mic-recording.png";
import micDefault from "../../../../../../../images/mic-normal.png";
import sumbitIcon from "../../../../../../../images/submit-white.png";
import avatarIcon from "../../../../../../../images/chat-user.png";
import systemIcon from "../../../../../../../images/chat-avt.png";
import {
  getDraftSkills,
  setDraft,
  executeFlow,
} from "../../../../../../../redux/actions/skill";

const ChatBot = ({ chatHistoryFlag, setChatHistoryFlag, chatHistoryItem }) => {
  const [_chatHistoryList, _setChatHistoryList] = useState([]);

  const [_trainedDataList, _setTrainedDataList] = useState([]);

  const trainedDataList = useSelector(
          (state) => state.collectionReducer.trainedData
  );

  useEffect(() => {
          _setTrainedDataList(trainedDataList);
  }, [trainedDataList]);

  const chatHistoryDataList = useSelector(
    (state) => state.collectionReducer.chatHistoryData
  );

  useEffect(() => {
    const item = chatHistoryItem;
    setQueryData([]);
    setQueryResponse("");
    const query = (
      <div className="mac-chat mac-right">
        <div className="mac-text">
          <p className="mac-black">{item.question}</p>
        </div>
        <div className="mac-avt">
          <img src={avatarIcon} alt="" />
        </div>
      </div>
    );

    chatHistoryItem?.length > 0
      ? setQueryData((current) => [queryBody, ...current])
      : setQueryData((current) => [query, ...current]);

    if (item.question?.length > 0) {
      let htmlResponseParsed = marked(item.answer);
      htmlResponseParsed = htmlResponseParsed.replaceAll(
        "href=",
        'target="_blank" href='
      );

      const queryTemp = (
        <div className="mac-chat mac-left">
          <div className="mac-avt">
            <img src={systemIcon} alt="" />
          </div>
          <div className="mac-text">
            {/* Play Text  */}
            <div className="mac-icon-select">
              {/* Select Language */}
              {/* <Tooltip title="Select Voice Language">
                  <Select
                    defaultValue={
                      selectedVoiceRef?.current?.length
                        ? selectedVoiceRef?.current == "hi-IN-AditiNeural"
                          ? "हिन्दी"
                          : "English"
                        : voicesRef.current[0].name == "Google हिन्दी"
                        ? "हिन्दी"
                        : "English"
                    }
                    style={{
                      width: 150,
                    }}
                    onChange={handleUpdateVoice}
                    placeholder="Select Language"
                  >
                    <Option>
                      <Option value="en-US-David">English"</Option>

                      <Option value="hi-IN-AditiNeural">"हिन्दी"</Option>
                    </Option>
                  </Select>
                </Tooltip> */}
              {/* <div className="mac-icon-click">
                  <Tooltip title="Read aloud">
                    <button
                      onClick={() => {
                        speechRef.current = item.answer;
                        handlePlay();
                      }}
                      className={"m-chat-play"}
                    >
                      <PlayCircleOutlined className="play-icon" />
                    </button>
                  </Tooltip>
                  <Tooltip title="Stop audio">
                    <button
                      onClick={() => {
                        speechRef.current = item.answer;
                        handlePause();
                      }}
                      className={"m-chat-play active"}
                    >
                      <PauseCircleOutlined className="pause-icon" />
                    </button>
                  </Tooltip>
                </div> */}
            </div>
            <p
              className="mac-white"
              dangerouslySetInnerHTML={{ __html: htmlResponseParsed }}
            ></p>

            {/* <span className="suggestion">If the given answer doesn't help, press <i className="fa fa-thumbs-down inline-thumb" /> to search from public knowledge (may not be accurate).</span> */}
            <div className="thumbs-action mac-text-thumbs">
              <i
                className="fa fa-thumbs-up"
                onClick={() => {
                  setLiked(true);
                }}
              ></i>
              <i
                className="fa fa-thumbs-down"
                onClick={() => {
                  setDisliked(true);
                }}
              ></i>
            </div>
          </div>
        </div>
      );
      setQueryData((current) => [queryTemp, ...current]);
    }
  }, [chatHistoryItem]);

  useEffect(() => {
    _setChatHistoryList(chatHistoryDataList);
  }, [chatHistoryFlag]);

  const userDeviceId = useSelector((state) => state.skillReducer.draftSession);
  const userDetails = useSelector(
    (state) => state.organizationReducer.currentOrganization
  );

  useEffect(() => {
    dispatch(getTrainedDataV2(collectionName));
    setQueryData(queryBody);
  }, []);

  const handlePause = () => {
    let audioElement = document.getElementById("audioPlayer");
    audioElement.pause();
    audioElement.currentTime = 0;
  };

  const speakText = (response) => {
    let lang = selectedVoiceRef.current ? selectedVoiceRef.current : "en-US	";
    let audio = dispatch(getAudio(lang, response));
  };

  const executeSkill = async (skill) => {
    let data = {
      deviceId: userDeviceId,
      skillId: skill?.id,
      bulk: false,
      restoreChrome: true,
    };
    if (userDeviceId) {
      await dispatch(executeFlow(data));
    } else {
      dispatch(
        notify(
          "error",
          "You are not connected to Super Assistant. Please install Super Assistant app."
        )
      );
    }
  };

  const handlePlay = () => {
    const textToSpeak = speechRef?.current;
    speakText(textToSpeak);
  };

  const [queryData, setQueryData] = useState([]);
  const [sendAnswer, setSendAnswer] = useState(false);
  const [micStatus, setMicStatus] = useState(false);
  const [fileList, setFileList] = useState([]);
  // const [chatHistoryFlag, setChatHistoryFlag] = useState(false);
  const [queryResponse, setQueryResponse] = useState("");
  const [queryResponseId, setQueryResponseId] = useState("");
  const [answerText, setAnswerText] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [chatGptQueryText, setChatGptQueryText] = useState("");
  const [disliked, setDisliked] = useState(false);
  const [liked, setLiked] = useState(false);
  const [queryText, setQueryText] = useState("");
  const [docSelected, setDocSelected] = useState("");
  const [chatContext, setChatContext] = useState(" ");
  const [walkthroughResponse, setWalkthroughResponse] = useState([]);
  const [editAnswerOldText, setEditAnswerOldText] = useState("");
  const [editQuestionText, setEditQuestionText] = useState("");
  const [questionText, setQuestionText] = useState("");
  const [micInputText, setMicInputText] = useState("");
  const [chartText, setChartText] = useState("");

  const speechRef = useRef(null);
  const selectedVoiceRef = useRef(null);
  const uploadRef = useRef(null);
  const queryParams = useLocation().search;
  const dispatch = useDispatch();

  const collectionName = new URLSearchParams(queryParams).get("name");
  const userEmail = useSelector((state) => state.userReducer.user?.email);
  const groupPlan = useSelector((state) => state.userReducer.groupPlan);
  let planType;
  if (groupPlan?.planId == 4) {
    planType = "team";
  } else if (groupPlan?.planId == 5) {
    planType = "business";
  } else {
    planType = "pro";
  }

  const collectionSource = useSelector(
    (state) => state.collectionReducer.collectionSource
  );

  let queryBody = [];
  queryBody.push(
    <div className="mac-chat mac-left">
      <div className="mac-avt">
        <img src={systemIcon} alt="" />
      </div>
      <div className="mac-text">
        <p className="mac-white">Hi, I'm Super</p>
        <p className="mac-white">How may I assist you today?</p>
      </div>
    </div>
  );

  const handleChange = ({ file, fileList: newFileList }) => {
    const docFileTypeArray = file?.name?.split(".");

    const docFileType = docFileTypeArray[docFileTypeArray?.length - 1];
    const validFileTypes = [
      "png",
      "jpg",
      "mp3",
      "mp4",
      "wav",
      "m4a",
      "mpeg",
      "flac",
    ];
    if (validFileTypes.includes(docFileType?.toLowerCase())) {
      setFileList(newFileList);
      if (newFileList[0]?.type?.includes("audio")) {
        setQueryText("Audio file uploaded");
      }
    } else {
      dispatch(notify("error", "Please select an allowed file format"));
    }
  };

  const convertArrayToMarkdownTable = (dataArray) => {
    if (!dataArray.length) return "";

    // Extract the keys for the header row from the first object
    const headers = Object.keys(dataArray[0]);
    const headerRow = `| ${headers.join(" | ")} |`;
    const separatorRow = `| ${headers.map(() => "---").join(" | ")} |`;
    // Create the rows for each object in the array
    const dataRows = dataArray.map((row) => {
      return `| ${Object.values(row).join(" | ")} |`;
    });
    // Combine header, separator, and data rows into a single markdown string
    return [headerRow, separatorRow, ...dataRows].join("\n");
  };

  const handleKeyPressOnSendAnswer = (event) => {
    if (event.key === "Enter") {
      sendUserAnswer();
    }
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const newCollectionQuery = async () => {
    setChatHistoryFlag(false);

    if (queryText?.length > 0) {
      // setImageUploadFlag(false);
      setFileList([]);

      if (queryResponse?.length > 0) {
        let markdownContent;
        if (Array.isArray(queryResponse)) {
          markdownContent = convertArrayToMarkdownTable(queryResponse);
        } else {
          markdownContent = queryResponse;
        }

        let htmlResponseParsed = marked(markdownContent);
        htmlResponseParsed = htmlResponseParsed.replaceAll(
          "href=",
          'target="_blank" href='
        );

        setQueryData((previousArr) =>
          previousArr.slice(-(previousArr?.length - 1))
        );
        const queryTemp = (
          <div className="mac-chat mac-left">
            <div className="mac-avt">
              <img src={systemIcon} alt="" />
            </div>
            <div className="mac-text">
              <p
                //className="mac-white"
                className={
                  Array.isArray(queryResponse) ? "data-chat-table" : "mac-white"
                }
                dangerouslySetInnerHTML={{ __html: htmlResponseParsed }}
              ></p>
              <div className="thumbs-action">
                <i className="fa fa-thumbs-up"></i>
                <i className="fa fa-thumbs-down"></i>
              </div>
            </div>
          </div>
        );
        setQueryData((current) => [queryTemp, ...current]);
      }

      setQueryResponse("");
      const query = (
        <div className="mac-chat mac-right">
          <div className="mac-text">
            <p className="mac-black">{queryText}</p>
            <p>
              <Space>
                {fileList?.map((obj, ind) => {
                  return <Image width={150} src={obj?.thumbUrl} />;
                })}
              </Space>
            </p>
          </div>
          <div className="mac-avt">
            <img src={avatarIcon} alt="" />
          </div>
        </div>
      );

      setChatGptQueryText(queryText);
      setQueryText("");
      setQueryData((current) => [query, ...current]);

      const message = (
        <div className="mac-chat mac-left">
          <div className="mac-avt">
            <img src={systemIcon} alt="" />
          </div>
          <div className="mac-text">
            <p className="typing">
              <span></span>
              <span></span>
              <span></span>
            </p>
          </div>
        </div>
      );
      setQueryData((current) => [message, ...current]);

      let docName = "";
      if ($(".tl-block").hasClass("active")) {
        docName = docSelected?.split(".")[0];
      }

      let imageFileData = [];
      fileList?.map((obj, ind) => {
        imageFileData.push(obj?.originFileObj);
      });

      let queryResult;

      const queryQuestion = queryText;
      if (collectionSource === "database") {
        queryResult = await getSqlQueryV2(queryQuestion, collectionName, planType);
        setChartText(queryResult?.text_content)
        setQueryResponse(queryResult.response);
      } else if (collectionSource === "live_search") {
        queryResult = await getLiveSearchQuery(
          queryQuestion,
          collectionName,
          planType
        );
      } else {
        queryResult = await queryDocumentV2(
          queryQuestion,
          collectionName,
          docName,
          chatContextEnabled ? chatContext : "",
          planType,
          imageFileData
        );
        setChartText(queryResult?.response[0]?.response?.text_content)
      }

      if (queryResult?.is_table === true) {
        const tableData = queryResult.response;
        const table = (
          <Table className="data-chat-table">
            <thead>
              <tr>
                {Object.keys(tableData[0]).map((key) => (
                  <th key={key}>{key}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, index) => (
                <tr key={index}>
                  {Object.values(row).map((value, idx) => (
                    <td key={idx}>{value}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>
        );
        setQueryData((previousArr) =>
          previousArr.slice(-(previousArr?.length - 1))
        );
        setQueryData((current) => [table, ...current]);

        setAnswerText("");
        setQuestionText("");
        setSendAnswer(false);
      }

      if (queryResult?.is_table === false) {
        const textData = queryResult.response;
        const query = (
          <div className="mac-chat mac-right">
            <div className="mac-text">
              <p className="mac-black">{answerText}</p>
            </div>
            <div className="mac-avt">
              <img src={avatarIcon} alt="" />
            </div>
          </div>
        );

        setQueryData((previousArr) =>
          previousArr.slice(-(previousArr?.length - 1))
        );
        setQueryData((current) => [query, ...current]);

        setAnswerText("");
        setQuestionText("");
        setSendAnswer(false);
      }

      if (queryResult?.is_visualization) {
        if (queryResult?.response[0]?.error) {
          setQueryData((previousArr) =>
            previousArr.slice(-(previousArr?.length - 1))
          );

          const query = (
            <div className="mac-chat mac-left">
              <div className="mac-avt">
                <img src={systemIcon} alt="" />
              </div>
              <div className="mac-text">
                <p className="mac-white">
                  Chart generation failed. Please rephrase the question and try
                  again.
                </p>
              </div>
            </div>
          );
          setQueryData((current) => [query, ...current]);
        } else {
          setQueryData((previousArr) =>
            previousArr.slice(-(previousArr?.length - 1))
          );

          queryResult?.response[0]?.response
            ? setQueryResponse(queryResult?.response[0]?.response)
            : setQueryResponse(queryResult?.response);
          setQueryResponseId(queryResult?.query_id);
        }
      } else {
        setWalkthroughResponse(queryResult?.skill_recommended);

        setQueryData((previousArr) =>
          previousArr.slice(-(previousArr?.length - 1))
        );

        setQueryResponse(queryResult?.response);
        setQueryResponseId(queryResult?.query_id);
        setQuestionText(queryText);

        setEditQuestionText(queryText);
        setEditAnswerOldText(queryResult?.response);
        setChatContext(queryResult?.chat_context);
      }
      dispatch(getChatHistoryV2(collectionName, userEmail));
      const textareaInput = document.getElementById("text-area-input");
      textareaInput.value = "";
    } else {
      dispatch(
        notify(
          "error",
          "Query field cannot be empty. Please enter a valid query"
        )
      );
    }
  };

  const getUserAnswer = async () => {
    setQueryResponse("");
    const query = (
      <div className="mac-chat mac-left">
        <div className="mac-avt">
          <img src={systemIcon} alt="" />
        </div>
        <div className="mac-text">
          <p className="mac-white">
            I'm sorry if my response didn't meet your expectations. Would you
            like to provide me the right answer so I can do better next time?
          </p>
          <div className="mac-flex-btn">
            <button
              className="btn btn-primary btn-rounded btn-small"
              onClick={(e) => {
                setSendAnswer(true);
                readInputAnswer();
              }}
            >
              Yes
            </button>
            <button
              className="btn btn-danger btn-rounded btn-small"
              onClick={() => {
                setSendAnswer(false);
                noAnswerSelected();
              }}
            >
              No
            </button>
          </div>
        </div>
      </div>
    );

    setQueryData((current) => [query, ...current]);
    //const queryResult = await getChatGPT(chatGptQueryText);
    //setQueryResponse(query)
  };

  const readInputAnswer = async () => {
    setQueryResponse("");
    setQueryData((previousArr) =>
      previousArr.slice(-(previousArr?.length - 1))
    );

    const staticQuery = (
      <div className="mac-chat mac-left">
        <div className="mac-avt">
          <img src={systemIcon} alt="" />
        </div>
        <div className="mac-text">
          <p className="mac-white">
            I'm sorry if my response didn't meet your expectations. Would you
            like to provide me the right answer so I can do better next time?
          </p>
          <div className="mac-flex-btn">
            <button className="btn btn-primary btn-rounded btn-small">
              Yes
            </button>
            <button className="btn btn-danger btn-rounded btn-small">No</button>
          </div>
        </div>
      </div>
    );

    setQueryData((current) => [staticQuery, ...current]);

    const query = (
      <div className="mac-chat mac-left">
        <div className="mac-avt">
          <img src={systemIcon} alt="" />
        </div>
        <div className="mac-text">
          <p className="mac-white">Enter your answer</p>
        </div>
      </div>
    );

    setQueryData((current) => [query, ...current]);
  };

  const noAnswerSelected = async () => {
    const query = (
      <div className="mac-chat mac-left">
        <div className="mac-avt">
          <img src={systemIcon} alt="" />
        </div>
        <div className="mac-text">
          <p className="mac-white">Thank you!</p>
        </div>
      </div>
    );

    setQueryData((current) => [query, ...current]);
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false, // allows the chart to be resized freely
    aspectRatio: 2,
  };

  const getChart = (chartData) => {
    switch (queryResponse?.chartType) {
      case "line":
        return (
          <p class="mac-white" style={{ width: '100%', height: '100%' }}>
            <Line 
            data={chartData}         
             />
          </p>
        );
      case "bar":
        return (
          <p class="mac-white" style={{ width: '100%', height: '100%' }}>
            <Bar data={chartData}
            />
          </p>
        );
      case "pie":
        return (
          <p class="mac-white" style={{ width: '70%', height: '70%' }}>
            <Pie data={chartData}           
            />
          </p>
        );
      case "doughnut":
        return (
          <p class="mac-white" style={{ width: '100%', height: '100%' }}>
            <Doughnut data={chartData}            
             />
          </p>
        );
      case "polarArea":
        return (
          <p class="mac-white" style={{ width: '100%', height: '100%' }}>
            <PolarArea data={chartData}          
             />
          </p>
        );
      case "radar":
        return (
          <p class="mac-white" style={{ width: '100%', height: '100%' }}>
            <Radar data={chartData}     
             />
          </p>
        );
      default:
        return null;
    }
  };

  const getDatabaseCollectionChart = (chartData) => {
    switch (collectionSource === "database" && queryResponse?.chartType) {
      case "line":
        return (
          <p class="mac-white" style={{ width: '100%', height: '100%' }}>
            <Line 
            data={chartData}
             />
          </p>
        );
      case "bar":
        return (
          <p class="mac-white" style={{ width: '100%', height: '100%' }}>
            <Bar data={chartData} 
            />
          </p>
        );
      case "pie":
        return (
          <p class="mac-white" style={{ width: '70%', height: '70%' }}>
            <Pie data={chartData}
            />
          </p>
        );
      case "doughnut":
        return (
          <p class="mac-white" style={{ width: '100%', height: '100%' }}>
            <Doughnut data={chartData} 
             />
          </p>
        );
      case "polarArea":
        return (
          <p class="mac-white" style={{ width: '100%', height: '100%' }}>
            <PolarArea data={chartData} 
             />
          </p>
        );
      case "radar":
        return (
          <p class="mac-white" style={{ width: '100%', height: '100%' }}>
            <Radar data={chartData} 
             />
          </p>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    if (disliked) {
      if (queryResponse?.chartType) {
        setQueryText("");
        let chartData = queryResponse?.data;

        setQueryData((previousArr) =>
          previousArr.slice(-(previousArr?.length - 1))
        );

        const query = (
          <div className="mac-chat mac-left">
            <div className="mac-avt">
              <img src={systemIcon} alt="" />
            </div>
            <div className="mac-text">
              {getChart(chartData)}

              <div className="thumbs-action">
                <i className="fa fa-thumbs-up"></i>
                <i className="fa fa-thumbs-down dislike"></i>
              </div>
            </div>
          </div>
        );

        setQueryData((current) => [query, ...current]);
        thumbsAction(queryResponseId, true);
      } else if (queryResponse?.length > 0) {
        // Check if queryResponse is an array
        let markdownContent;
        if (Array.isArray(queryResponse)) {
          markdownContent = convertArrayToMarkdownTable(queryResponse);
        } else {
          markdownContent = queryResponse; // Assuming it's already a string
        }
        let htmlResponseParsed = marked(markdownContent);
        htmlResponseParsed = htmlResponseParsed.replaceAll(
          "href=",
          'target="_blank" href='
        );

        setQueryData((previousArr) =>
          previousArr.slice(-(previousArr?.length - 1))
        );
        const query = (
          <div className="mac-chat mac-left">
            <div className="mac-avt">
              <img src={systemIcon} alt="" />
            </div>
            <div className="mac-text">
              <p
                //className="mac-white"
                className={
                  Array.isArray(queryResponse) ? "data-chat-table" : "mac-white"
                }
                dangerouslySetInnerHTML={{ __html: htmlResponseParsed }}
              ></p>
              <div className="thumbs-action">
                <i className="fa fa-thumbs-up"></i>
                <i className="fa fa-thumbs-down dislike"></i>
              </div>
            </div>
          </div>
        );

        setQueryData((current) => [query, ...current]);
        thumbsAction(queryResponseId, false);

        if (userDetails?.role_id != "1") {
          getUserAnswer();
        }
      }
      setDisliked(false);
    }
  }, [disliked]);

  useEffect(() => {
    if (liked) {
      if (queryResponse?.chartType) {
        setQueryText("");
        let chartData = queryResponse?.data;

        setQueryData((previousArr) =>
          previousArr.slice(-(previousArr?.length - 1))
        );

        const query = (
          <div className="mac-chat mac-left">
            <div className="mac-avt">
              <img src={systemIcon} alt="" />
            </div>
            <div className="mac-text">
              {getChart(chartData)}
              <div className="thumbs-action">
                <i className="fa fa-thumbs-up liked"></i>
                <i className="fa fa-thumbs-down"></i>
              </div>
            </div>
          </div>
        );

        setQueryData((current) => [query, ...current]);
        thumbsAction(queryResponseId, true);
      } else if (queryResponse?.length > 0) {
        // Check if queryResponse is an array
        let markdownContent;
        if (Array.isArray(queryResponse)) {
          markdownContent = convertArrayToMarkdownTable(queryResponse);
        } else {
          markdownContent = queryResponse; // Assuming it's already a string
        }
        let htmlResponseParsed = marked(markdownContent);
        htmlResponseParsed = htmlResponseParsed.replaceAll(
          "href=",
          'target="_blank" href='
        );

        setQueryData((previousArr) =>
          previousArr.slice(-(previousArr?.length - 1))
        );

        const query = (
          <div className="mac-chat mac-left">
            <div className="mac-avt">
              <img src={systemIcon} alt="" />
            </div>
            <div className="mac-text">
              <p
                className="mac-white"
                dangerouslySetInnerHTML={{ __html: htmlResponseParsed }}
              ></p>
              <div className="thumbs-action">
                <i className="fa fa-thumbs-up liked"></i>
                <i className="fa fa-thumbs-down"></i>
              </div>
            </div>
          </div>
        );
        setQueryData((current) => [query, ...current]);
        thumbsAction(queryResponseId, true);
      }
      setLiked(false);
    }
  }, [liked]);

  useEffect(() => {
    if (queryResponse?.chartType) {
      setQueryText("");
      let chartData = queryResponse?.data;

      if (collectionSource === "database") {
        let htmlResponseParsed = marked(chartText);
        const query = (
          <div className="mac-chat mac-left">
            <div className="mac-avt">
              <img src={systemIcon} alt="" />
            </div>
            <div className="mac-text">
              {getDatabaseCollectionChart(chartData)}
              <p className="mac-white"
                dangerouslySetInnerHTML={{ __html: htmlResponseParsed }}
              ></p>  
              <div className="thumbs-action mac-text-thumbs">
                <i
                  className="fa fa-thumbs-up"
                  onClick={() => {
                    setLiked(true);
                  }}
                ></i>
                <i
                  className="fa fa-thumbs-down"
                  onClick={() => {
                    setDisliked(true);
                  }}
                ></i>
              </div>
            </div>
          </div>
        );

        setQueryData((current) => [query, ...current]);
      } else {
        let htmlResponseParsed = marked(chartText);
        const query = (
          <div className="mac-chat mac-left">
            <div className="mac-avt">
              <img src={systemIcon} alt="" />
            </div>
            <div className="mac-text">
              {getChart(chartData)}
              <p className="mac-white"
                dangerouslySetInnerHTML={{ __html: htmlResponseParsed }}
              ></p>              
              <div className="thumbs-action mac-text-thumbs">
                <i
                  className="fa fa-thumbs-up"
                  onClick={() => {
                    setLiked(true);
                  }}
                ></i>
                <i
                  className="fa fa-thumbs-down"
                  onClick={() => {
                    setDisliked(true);
                  }}
                ></i>
              </div>
            </div>
          </div>
        );

        setQueryData((current) => [query, ...current]);
      }
    } else if (queryResponse?.length > 0) {
      // Check if queryResponse is an array
      let markdownContent;
      if (Array.isArray(queryResponse)) {
        markdownContent = convertArrayToMarkdownTable(queryResponse);
      } else {
        markdownContent = queryResponse; // Assuming it's already a string
      }
      // Convert the markdown content to HTML
      let htmlResponseParsed = marked(markdownContent);
      htmlResponseParsed = htmlResponseParsed.replaceAll(
        "href=",
        'target="_blank" href='
      );

      const query = (
        <div className="mac-chat mac-left">
          <div className="mac-avt">
            <img src={systemIcon} alt="" />
          </div>
          <div className="mac-text">
            {/* Play Text  */}
            <div className="mac-icon-select">
              {/* Select Language */}
              {/* <Tooltip title="Select Voice Language">
                  <Select
                    defaultValue={
                      selectedVoiceRef?.current == "hi-IN-AditiNeural"
                        ? "हिन्दी"
                        : "English"
                    }
                    style={{
                      width: 150,
                    }}
                    onChange={handleUpdateVoice}
                    placeholder="Select Language"
                  >
                    <Option>
                      <Option value="en-US-David">English"</Option>
  
                      <Option value="hi-IN-AditiNeural">"हिन्दी"</Option>
                    </Option>
                  </Select>
                </Tooltip> */}
              {/* <div className="mac-icon-click">
                  <Tooltip title="Read aloud">
                    <button
                      onClick={() => {
                        speechRef.current = queryResponse;
                        handlePlay();
                      }}
                      className={"m-chat-play"}
                    >
                      <PlayCircleOutlined className="play-icon" />
                      <PauseCircleOutlined className="pause-icon" />
                    </button>
                  </Tooltip>
                  <Tooltip title="Stop audio">
                    <button
                      onClick={() => {
                        speechRef.current = queryResponse;
                        handlePause();
                      }}
                      className={"m-chat-play active"}
                    >
                      <PlayCircleOutlined className="play-icon" />
                      <PauseCircleOutlined className="pause-icon" />
                    </button>
                  </Tooltip>
                </div> */}
            </div>
            <p
              className={
                Array.isArray(queryResponse) ? "data-chat-table" : "mac-white"
              }
              dangerouslySetInnerHTML={{ __html: htmlResponseParsed }}
            ></p>

            {/* <span className="suggestion">If the given answer doesn't help, press <i className="fa fa-thumbs-down inline-thumb" /> to search from public knowledge (may not be accurate).</span> */}
            <div className="thumbs-action mac-text-thumbs">
              <i
                className="fa fa-thumbs-up"
                onClick={() => {
                  setLiked(true);
                }}
              ></i>
              <i
                className="fa fa-thumbs-down"
                onClick={() => {
                  setDisliked(true);
                }}
              ></i>
            </div>
            {walkthroughResponse?.length > 0 ? (
              <h5>
                Need further guidance? Trigger any of the below related
                walkthroughs to get live assistance.
              </h5>
            ) : null}
            <div className="chat-btns">
              {walkthroughResponse?.map((obj, ind) => {
                return obj?.SKILL_NAME?.length < 25 ? (
                  <Button onClick={(e) => executeSkill(obj)} type="primary">
                    {obj?.SKILL_NAME}
                  </Button>
                ) : (
                  <Popover content={obj?.SKILL_NAME}>
                    <Button onClick={(e) => executeSkill(obj)} type="dashed">
                      {obj?.SKILL_NAME.slice(0, 25) + "..."}
                    </Button>
                  </Popover>
                );
              })}
            </div>
          </div>
        </div>
      );
      setQueryData((current) => [query, ...current]);
      setWalkthroughResponse([]);
    }
  }, [queryResponse]);

  const speechToText = () => {
    setMicStatus(true);

    var SpeechRecognition = SpeechRecognition || window.webkitSpeechRecognition;
    var recognition = new SpeechRecognition();

    recognition.onstart = () => {
      sendAnswer ? setAnswerText("Listening...") : setQueryText("Listening...");
    };

    recognition.onspeechend = () => {
      setMicStatus(false);
      recognition.stop();
      //sendAnswer ? setAnswerText('') : setQueryText('');
    };

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      sendAnswer ? setAnswerText(transcript) : setQueryText(transcript);
      setMicInputText(transcript);
    };

    recognition.start();
  };

  const sendUserAnswer = async () => {
    let docName = "";
    if ($(".tl-block").hasClass("active")) {
      docName = docSelected?.split(".")[0];
    }

    const query = (
      <div className="mac-chat mac-right">
        <div className="mac-text">
          <p className="mac-black">{answerText}</p>
        </div>
        <div className="mac-avt">
          <img src={avatarIcon} alt="" />
        </div>
      </div>
    );

    setQueryData((current) => [query, ...current]);

    setAnswerText("");
    setQuestionText("");
    setSendAnswer(false);

    const message = (
      <div className="mac-chat mac-left">
        <div className="mac-avt">
          <img src={systemIcon} alt="" />
        </div>
        <div className="mac-text">
          <p className="typing">
            <span></span>
            <span></span>
            <span></span>
          </p>
        </div>
      </div>
    );

    setQueryData((current) => [message, ...current]);

    const sendAnswerResponse = await sendInputAnswerV2(
      collectionName,
      queryResponseId,
      editQuestionText,
      editAnswerOldText,
      answerText,
      planType
    )
    dispatch(getTrainedDataV2(collectionName));
      

    setChatContext(" ");
    setQueryData((previousArr) =>
      previousArr.slice(-(previousArr?.length - 1))
    );

    if (sendAnswerResponse?.status == "OK") {
      const message = (
        <div className="mac-chat mac-left">
          <div className="mac-avt">
            <img src={systemIcon} alt="" />
          </div>
          <div className="mac-text">
            <p className="mac-white">
              Thank you for the details. I will update my knowledge and strive
              to provide more relevant answers next time.
            </p>
          </div>
        </div>
      );

      setQueryData((current) => [message, ...current]);
    } else {
      const message = (
        <div className="mac-chat mac-left">
          <div className="mac-avt">
            <img src={systemIcon} alt="" />
          </div>
          <div className="mac-text">
            <p className="mac-white">
              Something went wrong. Please try again later.
            </p>
          </div>
        </div>
      );

      setQueryData((current) => [message, ...current]);
    }
    const textareaInput = document.getElementById("text-area-input");
    textareaInput.value = "";
  };

  const handleButtonClick = (e) => {
    uploadRef.current?.upload?.uploader?.onClick(e);
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      newCollectionQuery();
    }
  };

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

    const [chatContextEnabled, setChatContextEnabled] = useState(true)
    const handleClick = () => {
      if (!chatContextEnabled) {
        setChatContextEnabled(true);
      } else {
        setChatContextEnabled(false)
      }
    }

  return (
    <div className="wk-chat">
      <div id="chat" className="scrollable chat-block-scroll">
        {queryData?.map((obj, ind) => {
          return obj;
        })}
      </div>
      {sendAnswer ? (
        <div className="chat-upload-text">
          <div className="chat-textbox">
            <div className="mic-attach">
              <div className="mic-chat">
                <img
                  src={micStatus ? micRecording : micDefault}
                  alt=""
                  onClick={speechToText}
                />
              </div>
            </div>
            <div className="input-block">
              <textarea
                id="text-area-input"
                className="text-chat-textarea"
                cols="100"
                style={{ resize: "none" }}
                value={answerText}
                onKeyPress={handleKeyPressOnSendAnswer}
                onChange={(e) => setAnswerText(e.target.value)}
                type="text"
                placeholder="Enter your answer here"
              ></textarea>
            </div>
            <div className="smile-submit">
              <button onClick={() => sendUserAnswer()}>
                Send <img src={sumbitIcon} alt="" />
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="chat-upload-text">
          <div
            className="upload-img-block"
            style={{
              display: fileList.length >= 1 ? "block" : "none",
            }}
          >
            <Upload
              beforeUpload={() => false}
              listType="picture-card"
              fileList={fileList}
              onPreview={handlePreview}
              onChange={handleChange}
              ref={uploadRef}
              accept=".jpg,.png,.pptx,.mp3,.mp4,.wav,.m4a,.mpeg,.flac"
            ></Upload>
            {previewImage && (
              <Image
                wrapperStyle={{
                  display: "none",
                }}
                preview={{
                  visible: previewOpen,
                  onVisibleChange: (visible) => setPreviewOpen(visible),
                  afterOpenChange: (visible) => !visible && setPreviewImage(""),
                }}
                src={previewImage}
              />
            )}
          </div>
          <div className="chat-textbox">
            {/* Switch Button */}
            <div className="context-btn">
              <span>Chat Context</span>
                <Switch defaultChecked onClick={handleClick} checked={chatContextEnabled} className="black-switch" />
            </div>
            {/* Switch Button */}
            <div className="mic-attach">
              <div className="mic-chat">
                <img
                  src={micStatus ? micRecording : micDefault}
                  alt=""
                  onClick={speechToText}
                />
              </div>

              <div className="attach-ico" onClick={handleButtonClick}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-paperclip"
                >
                  <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path>
                </svg>
              </div>
            </div>
            <div className="input-block">
              <textarea
                id="text-area-input"
                className="text-chat-textarea"
                cols="100"
                style={{
                  resize: "none",
                  minHeight: "30px",
                  background: "transparent",
                }}
                value={queryText}
                onKeyPress={handleKeyPress}
                onChange={(e) =>
                  setQueryText(e.target.value.replace(/[\n\r]/g, ""))
                }
                type="text"
                placeholder="Enter your message here"
              ></textarea>
            </div>
            <div className="smile-submit">
              <button onClick={() => newCollectionQuery()}>
                Send <img src={sumbitIcon} alt="" />
              </button>
            </div>
          </div>
        </div>
      )}
      <audio id="audioPlayer"></audio>
    </div>
  );
};
export default ChatBot;
